import PieChartWrapper from '@/components/list-view-visualisation/chart/PieChartWrapper'
import BarChartWrapper from '@/components/list-view-visualisation/chart/BarChartWrapper'
import StackedBarChartWrapper from '@/components/list-view-visualisation/chart/StackedBarChartWrapper'
import LineChartWrapper from '@/components/list-view-visualisation/chart/LineChartWrapper'
import MapChartWrapper from '@/components/list-view-visualisation/chart/MapChartWrapper'
import NumberTile from '@/components/list-view-visualisation/chart/NumberTile'
import WordCloud from '@/components/list-view-visualisation/chart/WordCloud'

export default {
  // place the chart type names in alphabetical order
  barChart: {
    path: 'bar-chart',
    name: 'list-view-visualisation-bar',
    displayNameKey: 'label.chart.bar',
    component: BarChartWrapper,
    showCategoryOptions: true,
    showSingleMeasureOptions: false,
    showMultiMeasureOptions: true,
    showGeoOptions: false,
    showTitleInput: true,
    showTitle: true,
    showListViewLink: true,
    showSeries: true,
  },
  stackedBarChart: {
    path: 'stacked-bar-chart',
    name: 'list-view-visualisation-stacked-bar',
    displayNameKey: 'label.chart.stackedbar',
    component: StackedBarChartWrapper,
    showCategoryOptions: true,
    showSingleMeasureOptions: false,
    showMultiMeasureOptions: true,
    showGeoOptions: false,
    showTitleInput: true,
    showTitle: true,
    showListViewLink: true,
    showSeries: true,
  },
  lineChart: {
    path: 'line-chart',
    name: 'list-view-visualisation-line',
    displayNameKey: 'label.chart.line',
    component: LineChartWrapper,
    showCategoryOptions: true,
    showSingleMeasureOptions: false,
    showMultiMeasureOptions: true,
    showGeoOptions: false,
    showTitleInput: true,
    showTitle: true,
    showListViewLink: true,
    showSeries: true,
  },
  mapChart: {
    path: 'map-chart',
    name: 'list-view-visualisation-map',
    displayNameKey: 'label.chart.map',
    component: MapChartWrapper,
    showCategoryOptions: false,
    showSingleMeasureOptions: false,
    showMultiMeasureOptions: false,
    showGeoOptions: true,
    showTitleInput: true,
    showTitle: true,
    showListViewLink: true,
    showSeries: false,
  },
  numberTile: {
    path: 'number-tile',
    name: 'list-view-visualisation-number-tile',
    displayNameKey: 'label.chart.numbertile',
    component: NumberTile,
    showCategoryOptions: false,
    showSingleMeasureOptions: true,
    showMultiMeasureOptions: false,
    showTitleInput: true,
    showGeoOptions: false,
    // numberTile uses internal title element to be able to adjust total height dynamically
    showTitle: false,
    // uses internal list view link
    showListViewLink: false,
    showSeries: false,
  },
  pieChart: {
    path: 'pie-chart',
    name: 'list-view-visualisation-pie',
    displayNameKey: 'label.chart.pie',
    component: PieChartWrapper,
    showCategoryOptions: true,
    showSingleMeasureOptions: true,
    showMultiMeasureOptions: false,
    showGeoOptions: false,
    showTitleInput: true,
    showTitle: true,
    showListViewLink: true,
    showSeries: false,
  },
  wordCloud: {
    path: 'word-cloud',
    name: 'list-view-visualisation-word-cloud',
    displayNameKey: 'label.chart.wordcloud',
    component: WordCloud,
    showCategoryOptions: false,
    showSingleMeasureOptions: false,
    showMultiMeasureOptions: false,
    showTitleInput: true,
    showGeoOptions: false,
    showTitle: true,
    showListViewLink: false,
    showSeries: false,
    showWordCloudKeywordSelector: true,
  },
}
